export enum UserTypeStatus {
  Universal = 'universal',
}
